import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";

import { RdwQueryKeys } from "components/RDW/queryKeys";
import { useTypedQuery } from "hooks";
import { ApiInstance } from "utils/Api";

const REG_NUMBER_LENGTH = 6;

const isValidRegNumber = (regNumber: string) => regNumber.toUpperCase().replace(/[^A-Z0-9]/g, "").length === REG_NUMBER_LENGTH;

type UseRdwDetailsQueryProps = {
  enabled?: boolean;
  regNumber?: string;
  country?: string | null;
};

export const useRdwDetailsQuery = ({ enabled = false, country, regNumber }: UseRdwDetailsQueryProps) => {
  const { t } = useTranslation();

  const { data, isFetching, refetch } = useTypedQuery({
    queryKey: RdwQueryKeys.details(regNumber),
    queryFn: async ({ endpoint, baseUrl, params }) => (await ApiInstance.post(endpoint, params, baseUrl)).data,
    enabled
  });

  const fetchRdwDetails = async () => {
    if (country && country !== "NL") return;
    if (!regNumber) return toast.error(t("v8_missing_registration_number", "Missing registration number"));
    if (!isValidRegNumber(regNumber)) return toast.error(t("v8_invalid_registration_number_for_rdw_data", "Invalid registration number for RDW data"));

    const { error } = await refetch();
    if (error) toast.error(error.message);
  };

  return { rdwDetails: data, isRdwFetching: isFetching, fetchRdwDetails };
};
